/* FormCheck Class qui permet de valider le contenu d'un formulaire
 * Exemple utilisation wshop-back/view/store/edit/store_edit.php

 * Mettre data-required sur le input/textarea/select pour rendre le champs obligatoire
 * Mettre data-rexexp="[formatFormCheck]" et choisir un formatFormCheck (key) pour le définir (exemple : data-rexexp="alpha")

 * Pour les checkbox (obligatoire) il faut les englober avec <div class="checkbox-container"></div>
 * Possibilite de mettre plusieurs formulaires. Les initialiser avec le code suivant :
 *
var form_store;
$(document).ready(function() {
    form_store = FormCheck;
    form_store.init('#storeForm');
});
*/

var formatFormCheck = [];
formatFormCheck['alpha'] = '^[a-zA-Z\u00C0-\u017F\' |-]+$';
formatFormCheck['num'] = '^[0-9]+$';
formatFormCheck['num_ext'] = '^[0-9_-]+$'; // Le numero mais avec des caractere supplementaire
formatFormCheck['telephone_fr'] = '^[0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$';
formatFormCheck['code_postal_fr'] = '^[0-9]{5}$';
formatFormCheck['email'] = '^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$';
formatFormCheck['HH:MM'] = '^(2[0-3]|1[0-9]|0[0-9]):([0-5][0-9])$';
formatFormCheck['DD/MM/YYYY'] = '^(3[0-1]|2[0-9]|1[0-9]|0[1-9])/(1[0-2]|0[1-9])/([0-9]{4})$';
formatFormCheck['relay'] = '^[0-9]{6}$';


// Pour verifier le formulaire
var FormCheck = {

	options: {
		'alert-box': '' // Le renseigner avec la class (ou l'id) de la box d'erreur (exemple : '.lightbox_error_rapport')
	},

    init: function(form_id, options) {

        var self = this;

        this.form_id = form_id;

        // Attribution des options pour les options de l'objet
		jQuery.extend(this.options, options);

        $(this.form_id+' input[type=text], '+this.form_id+' textarea, ' + this.form_id+' input[type=email]').each(function(){
            var element = $(this);
            if(element.data('required') == true || element.data('regexp') != undefined){
                element.on({
                    blur: function() {
                        self.checkField(element);
                    },
                    keyup: function() {
                        self.checkField(element);
                    }
                });
            }
        });

        // Les radios/checkbox (par defaut des que la personne click on desactive l'erreur)
        $(this.form_id+' input[type=radio], '+this.form_id+' input[type=checkbox]').each(function(){
            var element = $(this);
            if(element.data('required') == true || element.data('regexp') != undefined){
                element.on({
                    click: function() {
                        self.checkFieldRadioCheckbox(element);
                    }
                });
            }
        });
    },

    closeBoxError: function () {
        $('.lightbox_error_rapport').slideUp();
        $('#shad').hide();
    },

    // Par defaut des que la personne click on desactive l'erreur. Il y aura une verification au submit
    checkFieldRadioCheckbox: function (element) {
        element.parents('.checkbox-container').removeClass('invalid');
        return true;
    },

    checkField: function (element) {
        var dataReg = $(element).data('regexp');
        if (element.val().trim().length == 0 && element.data('required') == true) {
            element.addClass('invalid');
            return false;
        } else if (element.data('regexp') != undefined && element.val().trim().length > 0){
            if (dataReg != undefined) {
            	if (dataReg == 'telephone_autocomplete') {
            		/*
            		 * Doit toujours avoir un champs en hidden (qui transmet la bonne valeur au php)
            		 * $(objElement).intlTelInput("getNumberType") == 0 pour un fixe et $(objElement).intlTelInput("getNumberType") == 1 pour un mobile
            		 */
            		if ( element.intlTelInput("isValidNumber") === false ) {
			            element.addClass('invalid');
	                    return false;
			        } else {
			            $('#'+element.attr('id')+'_hidden').val(element.intlTelInput("getNumber"));
			        }
            	} else {
	                var reg_exp = new RegExp(formatFormCheck[dataReg],'gi');
	                // verification du formatage
	                if (!reg_exp.test(element.val())) {
	                    element.addClass('invalid');
	                    return false;
	                }
            	}
            }
        } else if (dataReg != undefined) {
            if (dataReg == 'telephone_autocomplete') {
			    $('#'+element.attr('id')+'_hidden').val('');
            }
        }
        element.removeClass('invalid');

        return true;
    },

    submit: function () {

        var self = this;
        var error_txt = [];

        var checkG = true;
        $(this.form_id+' input[type=text], '+this.form_id+' textarea, ' + this.form_id+' input[type=email]').each(function() {
            check = self.checkField($(this));
            if ( typeof $(this).data('error') != 'undefined' && !check )
            	error_txt.push($(this).data('error'));
            if (checkG)
                checkG = check;
        });

        var response = grecaptcha.getResponse();
        if(response.length == 0){
            $('.g-recaptcha').addClass('recaptchaInvalide');
            return false;
        }
        else{
            $('.g-recaptcha').removeClass('recaptchaInvalide');
        }

        var groupCheck = [];
        // Il y a un probleme pour le $.each quand on met des key en string donc on vas inscrementer les key en fonction du name precedent et le name courant
        var name_cur = name_prev = '';
        var i = -1;
        // La verification des bouton radio se fait uniquement dans le submit
        $(this.form_id+' input[type=radio], '+this.form_id+' input[type=checkbox]').each(function() {
            if ($(this).data('required') == true) {
                name_cur = $(this).attr('name');
                // Si le nom courant est different du precedent alors on inscremente
                if (name_cur != name_prev) {
                    i++ ;
                    name_prev = name_cur;
                    groupCheck[i] = {'checked': [], 'parent': []};
                }
                // On prend comme cle le name des radio/chekbox pour les mettre en groupe
                if ($(this).prop('checked')) {
                    groupCheck[i].checked = true;
                    groupCheck[i].parent = $(this).parents('.checkbox-container');
                }
                else if (groupCheck[i].checked != true) { // On regarde si dans le groupe il n'y a pas deja une checkbox de coche
                    groupCheck[i].checked = false;
                    groupCheck[i].parent = $(this).parents('.checkbox-container');
                }
            }
        });

        // On parcourt tous les groupes de checkbox
        $.each(groupCheck, function(index, value) {
            if (value.checked == false) {
                checkG = false;
                value.parent.addClass('invalid');
            } else {
                value.parent.removeClass('invalid');
            }
        });

        if (checkG) {
            // On traque lorsqu'un utilisateur postule
            if (this.form_id == '#offersForm') {
                var job = $('#offersForm').find('select').val();
                fbq('track', 'CompleteRegistration', {
                    content_name: job,
                });

                $('body').append('<img height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=85469&conversionId=140129&fmt=gif" />');
            }
            return true;
        } else if (this.options.alerte_box != '') {
            $('#shad').show();
            var msg = 'Un ou plusieurs champs obligatoire n\'ont pas été remplis correctement';
            // Indication des champs erronés
            var length = error_txt.length;
            for (var i = 0 ; i < length ; i++)
            	msg += '<div class="error_line"> - ' + error_txt[i] + '</div>';
            $(this.options.alerte_box).find('.rapport').html(msg);
            $(this.options.alerte_box).slideDown();
        }
        return false;
    }
}


$(function(){
    // INSCRIPTION NEWSLETTER
    $('#newsletterForm').submit(function(event){
        event.preventDefault();
        $('#error_newsletter').hide();
        mail = $('#email').val();
        nom = $('#nom').val();
        prenom = $('#prenom').val();
        societe = $('#societe').val();
        optin = $('#optin').val();

        $.ajax({
            type: "POST",
            url:  path_root+"includes/ajax_inscription_news.php",
            data: {mail: mail, nom: nom, prenom: prenom, societe: societe, optin: optin, submit: true}
        }).done(function( msg ) {
            if(msg != 'ok') {

                var errors = $.parseJSON(msg);
                $string_error = '';

                if(errors.mail_exists) {
                    $string_error += "L\'adresse mail est déjà inscrite<br />";
                    $('#email').parent().css('border','1px solid red');
                    $('#email').focus();
                }
                else if(errors.mail_empty) {
                    $string_error += "L\'adresse mail doit être renseignée<br />";
                    $('#email').parent().css('border','1px solid red');
                    $('#email').focus();
                }
                else if(errors.mail_error) {
                    $string_error += "L\'adresse mail n\'est pas valide<br />";
                    $('#email').parent().css('border','1px solid red');
                    $('#email').focus();
                }
                else {
                    $('#email').parent().css('border', 'none');
                }

                if(errors.nom_empty) {
                    $string_error += "Le nom doit être renseigné<br />";
                    $('#nom').parent().css('border','1px solid red');
                    $('#nom').focus();
                }
                else if(errors.nom_error) {
                    $string_error += "Le nom n\'est pas valide<br />";
                    $('#nom').parent().css('border','1px solid red');
                    $('#nom').focus();
                }
                else {
                    $('#nom').parent().css('border', 'none');
                }

                if(errors.prenom_empty) {
                    $string_error += "Le prénom doit être renseigné<br />";
                    $('#prenom').parent().css('border','1px solid red');
                    $('#prenom').focus();
                }
                else if(errors.prenom_error) {
                    $string_error += "Le prénom n\'est pas valide<br />";
                    $('#prenom').parent().css('border','1px solid red');
                    $('#prenom').focus();
                }
                else {
                    $('#prenom').parent().css('border', 'none');
                }

                $('#error_newsletter').html($string_error).fadeIn('fast');

            } else {
                $('#error_newsletter').html("Votre demande a bien été prise en compte").fadeIn('fast');
                $('#email').parent().css('border', 'none');
                $('#nom').parent().css('border', 'none');
                $('#prenom').parent().css('border', 'none');
                $('#societe').parent().css('border', 'none');

                // On traque l'inscription à la newsletter
                fbq('track', 'Lead', {
                    content_name: 'newsletter',
                });

                setTimeout(function(){
                  window.location.href = "http://www.webpopulation.fr/";
                }, 5000);

            }
        });

        return false;
    });

    // DESINSCRIPTION NEWSLETTER
     $('#newsletterUnsubscribeForm').submit(function(){
        $('#error_newsletter').hide();
        var mail = $('#email').val();
        var optin = $('#optin').val();

        $.ajax({
            type: "POST",
            url: path_root+"includes/ajax_desinscription_news.php",
            data: { mail: mail, optin:optin, submit: true }
        }).done(function( msg ) {
            if(msg != 'ok') {
                var errors = $.parseJSON(msg);
                    if(errors.mail_not_exists) {
                        $('#error_newsletter').html("Désolé, ce mail ne fait pas partie de notre base").fadeIn('fast');
                        $('#email').parent().css('border','1px solid red');
                        $('#email').focus();
                    }
                    if(errors.mail_empty) {
                        $('#error_newsletter').html("L\'adresse mail doit être renseignée").fadeIn('fast');
                        $('#email').parent().css('border','1px solid red');
                        $('#email').focus();
                    }
                    if(errors.mail_error) {
                        $('#error_newsletter').html("L\'adresse mail n\'est pas valide").fadeIn('fast');
                        $('#email').parent().css('border','1px solid red');
                        $('#email').focus();
                    }
            } else {
                $('#error_newsletter').html("Votre demande a bien été prise en compte").fadeIn('fast');
                $('#email').parent().css('border','none');

                setTimeout(function(){
                  window.location.href = "http://www.webpopulation.fr/";
                }, 5000);
            }
        });
        return false;
    });
});

var form;
$(function(){
	if ( $('#contactForm').length > 0 ) {
	    form = FormCheck;
	    form.init('#contactForm');
	} else 	if ( $('#offersForm').length > 0 ) {
	    form = FormCheck;
	    form.init('#offersForm');
	}
});
